import React, { useEffect, useState, useRef } from "react";
import "./ChatDashboard.scss";
import { useDispatch, useSelector } from "react-redux";
import {
	getMessageByChatId,
	markMessagesAsRead,
	deleteMessage,
	approveOneLinkRequest,
	rejectOneLinkRequest,
	getUserByIdBody,
	getStartUpById
} from "../../../../Service/user";

import AfterSuccessPopUp from "../../../../components/PopUp/AfterSuccessPopUp/AfterSuccessPopUp";
import ChatDeletePopup from "../ChatDeletePopup/ChatDeletePopup";
import ChatInputContainer from "../../../../components/Investor/ChatComponents/ChatInputContainer/ChatInputContainer";
import MyMessage from "../../../../components/Investor/ChatComponents/ChatMessages/MyMessage/MyMessage";
import OtherMessage from "../../../../components/Investor/ChatComponents/ChatMessages/OtherMessage/OtherMessage";
import { formatMessages } from "../../../../utils/ChatsHelpers";
import TCHLogoLoader from "../../../../components/Shared/TCHLoaders/TCHLogoLoader/TCHLogoLoader";
import { selectLoggedInUserId, selectUserCompanyData } from "../../../../Store/features/user/userSlice";
import NavBar from "../../../../components/NewInvestor/NavBar/NavBar";
import CommunityChatBg from "../../../../Images/Chat/CommunityChatBg.png";
import { Link } from "react-router-dom";

const ChatDashboard = ({ setSendMessage, recieveMessage, cleared }) => {
	// Fetch global state
	const loggedInUserId = useSelector(selectLoggedInUserId);
	const chatId = useSelector((state) => state.chat.chatId);
	const userId = useSelector((state) => state.chat.userId);
	const dispatch = useDispatch();
	const userCompanyData = useSelector(selectUserCompanyData);
	const [messages, setMessages] = useState([]);
	const [formattedMessages, setFormattedMessages] = useState([]);
	const chatMessagesContainerRef = useRef(null);
	const [isSent, setIsSent] = useState(false);

	const [showFeaturedPostSuccess, setShowFeaturedPostSuccess] = useState(false);
	const [founderData, setFounderData] = useState({});
	const [startupData, setStartupData] = useState({});
	const [deletePopup, setDeletePopup] = useState(false);
	const [msgId, setMsgId] = useState("");
	const [loading, setLoading] = useState(false);
	const [oneLinkRequests, setOneLinkRequests] = useState({});
	const [showSecretKey, setShowSecretKey] = useState({});
	const [loadingRequests, setLoadingRequests] = useState({});

	const handleSetDeletePopup = () => {
		setDeletePopup(true);
	};
	const handleIdBack = (data) => {
		setMsgId(data);
	};

	const handleDeleteOk = async () => {
		if (!msgId) {
			return;
		}

		try {
			const result = await deleteMessage(msgId);
			if (result) {
				setShowFeaturedPostSuccess(true);
				setDeletePopup(false);
				setMessages((prev) => {
					return prev.filter((message) => {
						if (message.id) {
							return message.id !== msgId;
						}
						return message;
					});
				});
			}
		} catch (error) {
			console.error("Error likeDislike comment : ", error);
		}
	};

	// Modify fetchOneLinkRequestStatus to also return founderId
	const fetchOneLinkRequestStatus = async (startupId, requestId) => {
		try {
			const response = await getStartUpById(startupId);
			const startup = response.data.data;
			setStartupData(startup);
			const founderDetails = await getUserByIdBody(startup.founderId);
			setFounderData(founderDetails.data);
			if (startup && startup.oneLinkRequest) {
				const request = startup.oneLinkRequest.find(
					req => req._id === requestId
				);
				return {
					status: request ? request.status : null,
					founderId: startup.founderId
				};
			}
			return { status: null, founderId: null };
		} catch (error) {
			console.error("Error fetching OneLink request status:", error);
			return { status: null, founderId: null };
		}
	};

	// Modify handleOneLinkAction
	const handleOneLinkAction = async (messageId, startupId, action, requestId) => {
		try {
	
			if (action === "approved") {
			const response = await approveOneLinkRequest(startupId, requestId);
			} else if (action === "rejected") {
				await rejectOneLinkRequest(startupId, requestId);
			}
			
			// Refresh the OneLink request status
			const newStatus = await fetchOneLinkRequestStatus(startupId, requestId);
			setOneLinkRequests(prev => ({
				...prev,
				[messageId]: newStatus
			}));
		} catch (error) {
			console.error("Error handling OneLink action:", error);
		}
	};

	// Update formattedMessages when messages change
	useEffect(() => {
		const formatted = formatMessages(messages, loggedInUserId);
		setFormattedMessages(formatted);
	}, [messages, loggedInUserId]);

	// Move the OneLink status fetch to depend on formattedMessages state
	useEffect(() => {
		const fetchRequestStatuses = async () => {
			for (const group of formattedMessages) {
				for (const message of group.messages) {
					if (message.id === "onelinkrequest") {
						setLoadingRequests(prev => ({
							...prev,
							[message._id]: true
						}));
						const status = await fetchOneLinkRequestStatus(
							message.onelink_request.startupId,
							message.onelink_request.requestId
						);
						setOneLinkRequests(prev => ({
							...prev,
							[message._id]: status
						}));
						setLoadingRequests(prev => ({
							...prev,
							[message._id]: false
						}));
					}
				}
			}
		};

		if (formattedMessages.length > 0) {
			fetchRequestStatuses();
		}
	}, [formattedMessages, loggedInUserId]);

	useEffect(() => {
		if (chatMessagesContainerRef.current) {
			chatMessagesContainerRef.current.scrollTop =
				chatMessagesContainerRef.current.scrollHeight;
		}
	}, [messages, recieveMessage]);

	useEffect(() => {
		markMessagesAsRead(chatId, userId)
			.then((response) => {})
			.catch((error) => {
				console.error("Error marking messages as read:", error);
			});
	}, [chatId, userId, recieveMessage]);

	useEffect(() => {
		if (recieveMessage !== null && recieveMessage?.chatId === chatId) {
			setMessages((prevMessages) => [...prevMessages, recieveMessage]);
		}
	}, [recieveMessage, chatId, dispatch]);

	useEffect(() => {
		setLoading(true);
		getMessageByChatId(chatId, loggedInUserId)
			.then((res) => {
				setMessages(res.data);
				setLoading(false);
			})
			.catch((error) => {
				console.error("Error-->", error);
			});
	}, [chatId, cleared, isSent]);

	return (
		<>
			<div className="chat_dashboard_container">
				<div className="chat_messages_group" ref={chatMessagesContainerRef}>
					{loading ? (
						<div className="d-flex h-100 justify-content-center align-items-center">
							<TCHLogoLoader />
						</div>
					) : (
						formattedMessages.map((group) => (
							<div key={group.date}>
								<h6 className="date_header px-3 py-1 my-2 bg-light rounded shadow-sm small">
									{group.date}
								</h6>
								<div className="chat_messages">
									{group.messages.map((message, idx) => {
										const isDeletedByUser =
											message.deletedBy?.includes(loggedInUserId) ?? false;

										if (isDeletedByUser) {
											return null;
										}

										// Special handling for OneLink request messages
										if (message.id === "onelinkrequest" && message.senderId._id !== loggedInUserId) {
											const requestData = oneLinkRequests[message._id];
											const isPending = requestData?.status === "pending";
											const isFounder = requestData?.founderId === loggedInUserId;
											
											return (
												<div className="onelink-request-message" key={message._id}>
													<OtherMessage
														message={message}
														idx={idx}
														isPersonalChat={true}
													/>
													{loadingRequests[message._id] ? (
														<div className="onelink-request-wrapper">
															<div className="status-badge-left">
																<div className="loader"></div>
															</div>
														</div>
													) : (
														<>
															{isPending && isFounder && (
																<div className="onelink-request-wrapper">
																	<div className="onelink-actions">
																		<button 
																			className="btn btn-success btn-sm"
																			onClick={() => handleOneLinkAction(message._id, userCompanyData._id, "approved", message.onelink_request.requestId)}
																		>
																			Approve
																		</button>
																		<button 
																			className="btn btn-danger btn-sm ms-2"
																			onClick={() => handleOneLinkAction(message._id, userCompanyData._id, "rejected", message.onelink_request.requestId)}
																		>
																			Reject
																		</button>
																	</div>
																</div>
															)}
															{requestData?.status && (
																<div className="onelink-request-wrapper">
																	<div className="status-badge-left">
																		<span>OneLink Request: </span>
																		<span className={`status-badge ${requestData.status}`}>
																			{requestData.status.charAt(0).toUpperCase() + requestData.status.slice(1)}
																		</span>
																	</div>
																</div>
															)}
														</>
													)}
												</div>
											);
										}

										return message.senderId._id === loggedInUserId ? (
											<div className="onelink-request-wrapper" key={message._id}>
												<MyMessage
													handleIdBack={handleIdBack}
													handleSetDeletePopup={handleSetDeletePopup}
													idx={idx}
													message={message}
												/>
												{message.id === "onelinkrequest" && (
													<div className="status-badge-right">
														{loadingRequests[message._id] ? (
															<div className="onelink-access-buttons">
																<div className="loader"></div>
															</div>
														) : (
															<>
																<span>OneLink Request: </span>
																<span className={`status-badge ${oneLinkRequests[message._id]?.status}`}>
																	{oneLinkRequests[message._id]?.status?.charAt(0).toUpperCase() + 
																	 oneLinkRequests[message._id]?.status?.slice(1)}
																</span>
																{oneLinkRequests[message._id]?.status === "approved" && (
																	<div className="onelink-access-buttons">
																		<Link 
																			to={`/onelink/${startupData.oneLink}/${founderData.oneLinkId}`}
																			className="btn btn-primary btn-sm"
																		>
																			Access OneLink
																		</Link>
																		{!showSecretKey[message._id] ? (
																			<button
																				className="btn btn-outline-primary btn-sm"
																				onClick={() => setShowSecretKey(prev => ({...prev, [message._id]: true}))}
																			>
																				View Secret Key
																			</button>
																		) : (
																			<div className="secret-key-display">
																				<span>Secret Key:</span>
																				<code>{founderData.secretKey || "Unable to fetch secret key"}</code>
																			</div>
																		)}
																	</div>
																)}
															</>
														)}
													</div>
												)}
											</div>
										) : (
											<div className="onelink-request-wrapper" key={message._id}>
												<OtherMessage
													message={message}
													idx={idx}
													isPersonalChat={true}
												/>
												{message.id === "onelinkrequest" && (
													<>
														{(() => {
															const requestData = oneLinkRequests[message._id];
															const isPending = requestData?.status === "pending";
															const isFounder = requestData?.founderId === loggedInUserId;
															
															return (
																<>
																	{isPending && isFounder && (
																		<div className="onelink-actions">
																			<button 
																				className="btn btn-success btn-sm"
																				onClick={() => handleOneLinkAction(message._id, userCompanyData._id, "approved", message.onelink_request.requestId)}
																			>
																				Approve
																			</button>
																			<button 
																				className="btn btn-danger btn-sm ms-2"
																				onClick={() => handleOneLinkAction(message._id, userCompanyData._id, "rejected", message.onelink_request.requestId)}
																			>
																				Reject
																			</button>
																		</div>
																	)}
																	{requestData?.status && (
																		<div className="status-badge-left">
																			<span>OneLink Request: </span>
																			<span className={`status-badge ${requestData.status}`}>
																				{requestData.status.charAt(0).toUpperCase() + 
																				 requestData.status.slice(1)}
																			</span>
																		</div>
																	)}
																</>
															);
														})()}
													</>
												)}
											</div>
										);
									})}
								</div>
							</div>
						))
					)}
				</div>
				<ChatInputContainer
					isSent={isSent}
					// setIsSent={setIsSent}
					setMessages={setMessages}
					setSendMessage={setSendMessage}
				/>

				{deletePopup ? (
					<ChatDeletePopup>
						<div className="d-flex flex-column  justify-content-center ">
							<h1>Delete permanently</h1>
							<hr className="p-0 m-1 " />
							<p>This message will be Deleted permeanently </p>
							<div className="d-flex flex-column flex-md-row mx-auto">
								<button
									className="popup-close-button "
									onClick={() => setDeletePopup(false)}
								>
									Cancel
								</button>
								<button
									className="popup-ok_button"
									onClick={() => handleDeleteOk()}
								>
									Ok
								</button>
							</div>
						</div>
					</ChatDeletePopup>
				) : (
					""
				)}

				{showFeaturedPostSuccess ? (
					<AfterSuccessPopUp
						onClose={() => setShowFeaturedPostSuccess(false)}
						successText="The message has been deleted successfully."
					/>
				) : (
					""
				)}
			</div>
		</>
	);
};

export default ChatDashboard;
